export class ImageSizeHelper {
  static calculateImageSize(imageElement, sizeVariant) {
    const longerImageSidePerVariant = {
      "small": 224,
      "right-fit": 562
    }

    const imageWidth = imageElement.naturalWidth
    const imageHeight = imageElement.naturalHeight
    let longerSide = [imageWidth, imageHeight].sort()[0]
    let shorterSide = [imageWidth, imageHeight].sort()[1]
    let newLongerSide = longerImageSidePerVariant[sizeVariant] || longerSide
    let newShorterSide = Math.round(shorterSide * (newLongerSide / longerSide))

    if (imageWidth > imageHeight) {
      // Panoramic image
      return {
        width: newLongerSide,
        height: newShorterSide,
      }
    } else {
      // Portrait image
      return {
        width: newShorterSide,
        height: newLongerSide,
      }
    }
  }
}
